'use client'

import Script from 'next/script'
import { useLocale } from 'next-intl'
import { ConsentGate } from '@/features/gdpr/consent-gate'
import { ExternalContentPlaceholder } from '@/features/gdpr/placeholders/external-content-placeholder'
import { THIRD_PARTY_PURPOSE } from '@/features/gdpr/use-purpose-consent'
import { parseLanguageFromLocale } from '@/setup/locales'
import { ExperiencesHeader } from './experiences-header'

export const ExperiencesLandingPage = () => {
    const locale = useLocale()
    const currentLanguage = parseLanguageFromLocale(locale)

    let localeExperiencesCode

    switch (currentLanguage) {
        case 'nl':
            localeExperiencesCode = 'elfsight-app-9464ddfe-1ab4-4964-a271-f9b73864be5f'
            break
        case 'en':
            localeExperiencesCode = 'elfsight-app-f8cd41da-3b7d-4ede-858e-87960ec3a3dd'
            break
        case 'de':
            localeExperiencesCode = 'elfsight-app-293d9c8e-e9b0-47a5-8b3d-7fb72fe25a04'
            break
        default:
            localeExperiencesCode = 'elfsight-app-f8cd41da-3b7d-4ede-858e-87960ec3a3dd'
    }

    return (
        <div className="w-full max-w-[1040px] px-4 mb-20">
            <ExperiencesHeader />
            <ConsentGate
                integrationId="elfsight"
                purposeId={THIRD_PARTY_PURPOSE}
                placeholder={(activate) => <ExternalContentPlaceholder onActivate={activate} />}
            >
                <Script
                    src="https://static.elfsight.com/platform/platform.js"
                    strategy="lazyOnload"
                />
                <div className={localeExperiencesCode} data-elfsight-app-lazy />
            </ConsentGate>
        </div>
    )
}
